import TOP_BARS from '@topBars';
import FOOTERS from '@footers';
import LOGIN_STATE from '../../components/login/loginState';
let routes = [
  /**
   * @description 登录页面
   * @function /login 登录页面
   * @param {Component} Login views/login/Login.vue
   * @param {Name} pathname login
   */
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/login')
  },
  /**
   * @description 注册页面
   * @function /register 注册页面
   * @param {Component} Regist views/login/Regist.vue
   * @param {Name} pathname register
   */
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '注册',
      topBar: TOP_BARS.NULL
    },
    props: {
      initState: LOGIN_STATE.REGIST
    },
    component: () => import('@/views/login')
  },
  /**
   * @description 重置密码页面
   * @function /reset 重置密码页面
   * @param {Component} Reset views/login/Reset.vue
   * @param {Name} pathname reset
   */
  {
    path: '/reset',
    name: 'reset',
    meta: {
      title: '重置密码',
      topBar: TOP_BARS.NULL
    },
    props: {
      initState: LOGIN_STATE.FIND_PASSWORD
    },
    component: () => import('@/views/login')
  },
  /**
   * @description 登录页面
   * @function /login 登录页面
   * @param {Component} Login views/login/Login.vue
   * @param {Name} pathname login
   */ {
    path: '/sl',
    name: 'sl-login',
    meta: {
      title: '登录',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/login/sl/index.vue')
  },
  /**
   * @description 使用条款页面
   * @function /agreement 使用条款页面
   * @param {Component} Agreement views/common/Agreement
   * @param {Name} pathname agreement
   */
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      title: '使用条款'
    },
    component: () => import('@/views/common/Agreement')
  },
  /**
   * @description 家长代付
   * @function /pay/admission-parent/:token 家长代付
   * @param { Component } Parent views/common/Parent
   * @param { Name } pathname pay-admission-parent
   */
  {
    path: '/pay/admission-parent/:token',
    name: 'pay-admission-parent',
    meta: {
      title: '家长代付',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/common/Parent')
  },
  /**
   * @description 家长代付
   * @function /pay/sbp-parent/:token 家长代付
   * @param { Component } Parent views/common/ParentSbp
   * @param { Name } pathname pay-sbp-parent
   */
  {
    path: '/pay/sbp-parent/:token',
    name: 'pay-sbp-parent',
    meta: {
      title: '家长代付',
      topBar: TOP_BARS.NULL
    },
    component: () => import('@/views/common/ParentSbp')
  },
  /**
   * @description 退费政策
   * @function /student/admission-notices 退费政策
   * @param { Component } notices views/student/Admission/notices
   * @param { Name } pathname pay-admission-notices
   */
  {
    path: '/student/admission-notices',
    name: 'pay-admission-notices',
    meta: {
      title: '退费政策'
    },
    component: () => import('@/views/student/Admission/Notice')
  },
  /**
   * @description 十二学院徽章展示
   * @function /12house 十二学院徽章展示
   * @param { Component } Houses views/common/Houses
   * @param { Name } pathname 12-house
   */
  {
    path: '/12house',
    name: '12-house',
    meta: {
      title: '学院徽章展示',
      topBar: TOP_BARS.NULL,
      footer: FOOTERS.NULL
    },
    component: () => import('@/views/common/Houses')
  },
  {
    path: '/hsylc/uploader/:role',
    meta: {
      title: 'HSYLC file uploader'
    },
    component: () => import('../../views/common/Uploader')
  },
  {
    path: '/schedule/:place/know',
    name: 'schedule-know',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/Know')
  },
  {
    path: '/schedule/:place/hxweek/detail',
    name: 'schedule-hxweek-detail',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/HxWeek/Detail')
  },
  {
    path: '/schedule/:place/hxweek',
    name: 'schedule-hxweek',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/HxWeek')
  },
  {
    path: '/schedule/:place/before',
    name: 'schedule-before',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/Before')
  },
  {
    path: '/schedule/:place/during',
    name: 'schedule-during',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/During')
  },
  {
    path: '/schedule/:place/after',
    name: 'schedule-after',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Section/After')
  },
  {
    path: '/schedule/:place',
    name: 'schedule',
    meta: {
      title: '家长陪伴页'
    },
    component: () => import('../../views/common/Schedule/Home')
  }
];
routes = routes.map(item => {
  let ret = { ...item };
  const isScheduleRoute = typeof ret.path === 'string' && ret.path.startsWith('/schedule');
  ret.meta = {
    topBar: isScheduleRoute ? TOP_BARS.NULL : TOP_BARS.NO_USER,
    ...ret.meta
  };
  return ret;
});
export default routes;
